export default {
  namespaced: true,
  ntechlab: {
    title: "Ntechlab",
    provider: "Proveedor",
    provider_section: "Selecciona un proveedor",
    master_account: {
      title: "Master Account",
      name: "Nombre",
      description: "Descripción",
      api_user: "Usuario API",
      api_password: "Contraseña API",
      api_server: "Servidor API"
    },
    watch_list: {
      title: "Lista",
      name: "Nombre",
      comment: "Comentario",
      color: "Color",
      camera_group: "Grupo de cámaras",
      master_account: "Cuenta maestra",
      enable_schedule_disable: "Habilitar pausas programadas",
      disable_schedule: "Deshabilitar programación",
      notify: "Notificar",
      acknowledge: "Acknowledge",
      face_threshold: "Umbral de rostro",
      body_threshold: "Umbral de cuerpo",
      car_threshold: "Umbral de coche",
      ignore_events: "Ignorar eventos",
      send_events_to_external_vms: "Enviar eventos a VMS externos",
      active_after: "Activo después",
      active_before: "Activo antes",
      disable_schedule_active: "Deshabilitar programación activa",
      disable_schedule_monday: "Deshabilitar programación lunes",
      disable_schedule_tuesday: "Deshabilitar programación martes",
      disable_schedule_wednesday: "Deshabilitar programación miércoles",
      disable_schedule_thursday: "Deshabilitar programación jueves",
      disable_schedule_friday: "Deshabilitar programación viernes",
      disable_schedule_saturday: "Deshabilitar programación sábado",
      disable_schedule_sunday: "Deshabilitar programación domingo",
      master_account_name: "Nombre de la cuenta maestra",
      default_configuration: "Configuración por defecto",
      title_schedule_disable: "Deshabilitar programación 00:00 - 00:00",
      info: "Información",
      reconogition_config: "Configuración de reconocimiento",
      schedule_settings: "Horarios de deshabilitación",
      type_alarm: "Tipo de alarma",
    },
    face: {
      image: "Imagen",
      name: "Nombre",
      active: "Activo",
      comment: "Comentario",
      master_account: "Cuenta maestra",
      watch_list: "Lista de vigilancia",
      created_at: "Fecha de creación",
      updated_at: "Fecha de actualización",
      title: "Rostros",
      features: "Características",
      already_face_added: "Rostro ya registrado",
      face_added_label: "Registrado",
    },
    camera: {
      title: "Cámaras",
      name: "Nombre",
      active: "Activo",
      comment: "Comentario",
      camera_group: "Grupo de cámaras",
      created_at: "Fecha de creación",
      updated_at: "Fecha de actualización",
      refresh: "Refrescar",
      camera: "Cámara",
      status: "Estado",
    },
    face_search: {
      title: "Búsqueda de Rostro",
      search: "Buscar",
      change_search: "Cambiar búsqueda",
      no_results_found: "No se encontraron resultados",
      no_face_detected: "No se detectó ningún rostro en la imagen",
      delete_image: "Eliminar imagen",
      full_image: "Imagen completa",
      invalid_format: "Formato no válido, sólo se aceptan imágenes .jpg, .jpeg o .png",
      max_size: "La imagen no debe pesar más de 2 MB",
      drag_to_map: "Arrastra para ver la ubicación",
      camera_without_location: "La cámara no tiene instalación ni coordenadas registradas",
    }

  }
};
